export default "__VITE_ASSET__2b47e328__"